import { render, staticRenderFns } from "./Lpp.vue?vue&type=template&id=aefb46b2&"
import script from "./Lpp.vue?vue&type=script&lang=js&"
export * from "./Lpp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aefb46b2')) {
      api.createRecord('aefb46b2', component.options)
    } else {
      api.reload('aefb46b2', component.options)
    }
    module.hot.accept("./Lpp.vue?vue&type=template&id=aefb46b2&", function () {
      api.rerender('aefb46b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/MyCover/Summaries/Tabs/Lpp.vue"
export default component.exports